import React, { ReactNode, useState } from 'react';
import NavBar from '../widgets/Navbar';
import FooterPage from '../widgets/FooterPage';
import ChatBox from '../components/Chatbox';
import { Outlet } from 'react-router-dom';

type Props = { children: ReactNode }

const DefaultLayout = () => {
  const [isChatOpen, setChatOpen] = useState(false);

  const toggleChat = () => {
      setChatOpen(!isChatOpen);
  };
  return (
    <div className='flex h-screen  flex-col' >
      <NavBar  />
      <div className="flex flex-col flex-grow overflow-y-auto w-full h-[90%]   ">

        <div className="flex flex-col flex-grow  w-full  bg-[#25AAE1] py-6 px-[10%]">
        <Outlet />
        </div>
        
        <div className="flex px-[10%] py-7 text-[27px] font-[500] text-[#3BA5D1]">
           copy right nexah {new Date().getFullYear()}
        </div>
      </div> 
    </div>
  );
};

export default DefaultLayout;


